import api from '../utils/api';

export const getDistrictQuotes = (districtId, filter) => {
    var data = { ...filter };
    var impersonate = getImpersonationDetails();
    if (data.isMyAccountPage == true && impersonate && impersonate.userImpersonatingID) {
        data.userId = impersonate.userImpersonatingID;
    }
    return api.post('/api/district/quotes/get-all/' + districtId, data);
}
//V2
export const getDistrictQuotesV2 = (districtId, filter) => {
    var data = { ...filter };
    var impersonate = getImpersonationDetails();
    if (data.isMyAccountPage == true && impersonate && impersonate.userImpersonatingID) {
        data.userId = impersonate.userImpersonatingID;
    }
    return api.post('/api/district/quotes/get-all-v2/' + districtId, data);
}

export const getTotalQuotes = (districtId, status) => {
    return api.post('/api/district/quotes/get-count/' + districtId + '/' + status);
}

export const getDistrictQuoteProducts = (quoteId) => {
    return api.post('/api/district/quotes/get-products/', { quoteId: quoteId });
}
//V2
export const getDistrictQuoteProductsV2 = (quoteId) => {
    return api.post('/api/district/quotes/get-products-v2/', { quoteId: quoteId });
}

export const getDistrictQuote = (quoteId) => {
    return api.post('/api/district/quotes/get-quote', { quoteId: quoteId });
}

export const editDistrictQuote = (quoteId) => {
    var data = { quoteId: quoteId };
    var impersonate = getImpersonationDetails();
    if (impersonate && impersonate.userImpersonatingID) {
        data.userId = impersonate.userImpersonatingID;
    }
    return api.post('/api/district/quotes/edit', data);
}

export const updateStatus = (quoteId, status) => {
    return api.post('/api/district/quotes/change-status', { quoteId: quoteId, status: status });
}

export const getQuoteIdByReviewing = (districtId) => {
    return api.post('/api/district/quotes/get-byreviewing', { districtId: districtId });
};

export const deleteQuoteById = (id) => {
    return api({
        url: '/api/district/quotes/delete-quote/' + id,
        method: 'GET',
    });
}
export const updateUnlockStatus = (quoteId, status) => {
    return api.post('/api/district/quotes/update-lock', { quoteId: quoteId, status: status });
}

export const getDistrictQuoteTypicalLayouts = (quoteId) => {
    return api.post('/api/district/quotes/get-getDistrictQuoteTypicalLayouts/', { quoteId: quoteId });
}

export const updateQuoteTypicalLayoutsLabel = (Id, Label) => {
    return api.post('/api/district/quotes/update-quote-typicallayouts/', { Id: Id, Label: Label });
}

export const updateDistrictQuoteTypicalLayoutsQuantity = (Id, Quantity) => {
    return api.post('/api/district/quotes/update-quote-typicallayouts/', { Id: Id, Quantity: Quantity });
}

export const getImpersonationDetails = () => {
    const data = sessionStorage.getItem('impersonationDetails');
    return data ? JSON.parse(data) : null;
}

export const getReportRowCount = (filter) => {
    return api.post('/api/district/quotes/report-rows', filter);
}

export const submitFinalQuoteDocument = (districtQuoteDocument) => {
    return api({
        url: '/api/district/quotes/upload-final-quote-document',
        method: 'POST',
        data: districtQuoteDocument,
    });
};

export const attachSignedPO = (quoteId, signedPO) => {
    return api.post('/api/district/quotes/attach-signed-po', { quoteId: quoteId, signedPO: signedPO });
}

export const submitQuoteSignedPoDocument = (districtQuoteSignedPODocument) => {
    return api({
        url: '/api/district/quotes/attach-signed-po-document',
        method: 'POST',
        data: districtQuoteSignedPODocument,
    });
};

export const updateQuoteBudgetYear = (quoteId, budgetYearId) => {
    return api.post(`/api/district/quotes/update-budget-year/${quoteId}/${budgetYearId}`);
};


export const saveQuoteFeedback = (quoteId, feedback) => {
    return api.post('/api/district/quotes/save-quote-feedback', { quoteId: quoteId, feedback: feedback });
}

export const getNotificationQuotes = (districtId) => {
    return api.post(`/api/district/quotes/get-notification-quotes/${districtId}`);
}

export const getTotalQuotesV2 = (districtId,) => {
    return api.post(`/api/district/quotes/get-notification-count/${districtId}`);
}

export const getOriginalQuoteRequest = (quoteId) => {
    return api.post('/api/district/quotes/get-original-quote-request/', { quoteId: quoteId });
}

export const getOriginalQuoteTypicalLayouts = (quoteId) => {
    return api.post('/api/district/quotes/get-original-quote-request-layouts/', { quoteId: quoteId });
}


export const getUserPermissionByQuote = (quoteId) => {
    return api({
        url: `/api/district/quotes/get-user-permission-by-quote/${quoteId}`,
        method: 'GET'
    })
}

export const resendDealerMail = (quoteId) => {
    return api.post(`/api/district/quotes/resend-dealer-mail/${quoteId}`);
}